import React, { FC, memo } from "react";

import { Container } from "./styled";
import { ContainerProps } from "../types";

export const DefaultAttributesContainer: FC<ContainerProps> = memo(({ attributes, renderElement }) => {
  return (
    <>
      {attributes?.map(({ name }) => (
        <Container key={name}>{renderElement({ id: name })}</Container>
      ))}
    </>
  );
});
